import { ClockCircleOutlined, PhoneOutlined } from '@ant-design/icons';
import { Alert, Space, Spin, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import PosButton from '@/components/PosButton';
import RechargeOptionalWrapper from '@/components/RechargeOptionalWrapper';
import UserGender from '@/components/User/Gender';
import UserName from '@/components/User/Name';
import UserDomainCountAsync from '@/components/User/UserDomainCountAsync';
import UserRelationBar from '@/components/User/UserRelationBar';
import { Order } from '@/models/order';
import { User, useRequestUserBasicInfo } from '@/models/user';
import { getUserAvatar } from '@/utils/uiHelper';
import { MoremeClientModalBinder } from '../../Moreme/MoremeClientBinder';
import styles from './style.less';
import UserConnector from './UserConnector';
import { useBaseInfo } from '@/context/BaseInfoContext';

type Props = {
  user: User;
  order: Order;
  onDataChange: (user?: User, order?: Order) => void;
};
const UserGuide: React.FC<Props> = ({ user: userProps, order, onDataChange }: Props) => {
  const {
    payload: user,
    send: requestUserInfo,
    loading: userInfoLoading,
    error: userInfoError,
  } = useRequestUserBasicInfo();
  const [bindMoremeOpen, setBindMoremeOpen] = useState(false);
  const [{ deviceAnalyzerEnabled }] = useBaseInfo();

  useEffect(() => {
    if (userProps.username) {
      requestUserInfo({
        pathVars: {
          username: userProps?.username,
        },
      });
    }
  }, [userProps?.username]);

  if (userInfoLoading) {
    return <Spin />;
  }

  if (userInfoError) {
    return <Alert type="error" message="客户信息获取失败，请通过订单查看用户信息" />;
  }

  if (!user) {
    return null;
  }

  return (
    <>
      <div className={styles.userGuide}>
        <div className={styles.bg} />

        <div className={styles.userGuideBaseInfo}>
          <div className={styles.left}>{getUserAvatar(user, { size: 45, style: { marginBottom: 15 } })}</div>
          <div className={styles.main}>
            <Typography.Title level={5}>
              <UserGender style={{ marginRight: 5 }} gender={user.gender} />
              <UserName user={user} />
            </Typography.Title>
            <div>
              <Typography.Text type={'secondary'}>
                <ClockCircleOutlined /> 加入时间: {user.addTime}
              </Typography.Text>
            </div>
            {user.mobile && (
              <div>
                <Typography.Text type={'secondary'}>
                  <PhoneOutlined /> {user.mobile}
                </Typography.Text>
              </div>
            )}
            <Space>
              <UserRelationBar user={user} />
            </Space>
            {user.memo ? <div>{user.memo}</div> : null}
          </div>
        </div>

        {user.weixinOpenid || user.weixinUnionid || user.alipayId ? (
          <div className={styles.userGuideExtra}>
            <div className={`${styles.item} `}>
              <h4>{user.point}</h4>
              <h5>积分</h5>
            </div>
            <div className={`${styles.item}`}>
              <h4>
                <UserDomainCountAsync type={'order'} userId={user.id} fallback={'-'} />
              </h4>
              <h5>累计订单</h5>
            </div>
            <div className={`${styles.item}`}>
              <h4>
                &yen; <UserDomainCountAsync type={'consume'} userId={user.id} fallback={'-'} />
              </h4>
              <h5>累计消费</h5>
            </div>
            <RechargeOptionalWrapper userInfo={user}>
              <div className={`${styles.item}`}>
                <h4>&yen; {user.balance}</h4>
                <h5>账户余额</h5>
              </div>
            </RechargeOptionalWrapper>
          </div>
        ) : null}
        {deviceAnalyzerEnabled && !user.moremeCid ? (
          <>
            <MoremeClientModalBinder
              open={bindMoremeOpen}
              user={user}
              onBindSuccess={(updatedUser: User) => {
                setBindMoremeOpen(false);
                onDataChange(updatedUser);
              }}
              onCancel={() => {
                setBindMoremeOpen(false);
              }}
            />
            <Alert
              style={{ marginTop: 5, marginBottom: 5 }}
              showIcon
              type={'error'}
              message={<Typography.Text strong>检测仪未绑定</Typography.Text>}
              description={
                <>
                  该客户尚未绑定检测仪，请在添加企微后，进入聊天工具栏【
                  <Typography.Text mark>仪器关联</Typography.Text>】，绑定该客户的检测仪账号
                  <PosButton
                    onClick={() => {
                      setBindMoremeOpen(true);
                    }}>
                    立即绑定
                  </PosButton>
                </>
              }
              // action={<PosButton>立即绑定</PosButton>}
            />
            <div className={'space-between'}>
              {/*<Button>关联到已有用户</Button>*/}
              {/*<Button>手动创建新用户</Button>*/}
            </div>
          </>
        ) : null}

        <UserConnector user={user} order={order} onDataChange={onDataChange} />
      </div>
    </>
  );
};

export default UserGuide;
